import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import * as Common from '_common';
import * as Utils from '_utils';
import { DebugPage } from './../../app/DebugPage';
import { Button, Property, IconClose, IconDone, useToggle } from '_components';
import * as Styles from './Inputs.module.scss';
export function InputBase(props) {
    const lang = Common.useLanguage();
    const classes = Utils.classNames({
        [Styles.is_valid]: props.isValid,
        [Styles.is_invalid]: props.isInvalid,
    });
    return (_jsx(Common.Component, { name: 'input', className: classes, children: _jsxs(Property, { title: Common.LocalText(props.label, lang), children: [_jsx("input", { type: props.type, className: "form-control", id: props.name, placeholder: Common.LocalText(props.placeholder, lang), value: props.value, onChange: props.onChange, autoComplete: props.autoComplete, onBlur: props.onBlur }), props.controls && _jsx("div", { className: Styles.controls, children: props.controls }), props.validationMessage && (_jsx("div", { className: Styles.feedback, children: props.validationMessage }))] }) }));
}
export function TextInput(props) {
    return _jsx(InputBase, { ...props, type: "text" });
}
export function PasswordInput(props) {
    return _jsx(InputBase, { ...props, type: "password" });
}
export function EditableProperty(props) {
    const [value, setValue] = React.useState(props.value);
    const [inEditMode, setEditMode] = React.useState(false);
    const lang = Common.useLanguage();
    React.useEffect(() => {
        setValue(props.value);
    }, [props.value]);
    function reset() {
        setValue(props.value);
        setEditMode(false);
    }
    function submit() {
        if (props.onSubmit) {
            props.onSubmit(value);
        }
        setEditMode(false);
    }
    function goEditMode() {
        if (!props.disabled) {
            setEditMode(true);
        }
    }
    const controls = (_jsxs(_Fragment, { children: [_jsx(Button, { onClick: () => submit(), children: _jsx(IconDone, {}) }), _jsx(Button, { onClick: () => reset(), children: _jsx(IconClose, {}) })] }));
    if (inEditMode) {
        return (_jsx(TextInput, { ...props, name: "prop", onChange: event => setValue(event.target.value), controls: controls, value: value ?? '' }));
    }
    else {
        if (props.hideTitle) {
            return (_jsx("a", { onClick: () => goEditMode(), href: "#", children: value ?? '--' }));
        }
        return (_jsx(Property, { title: Common.LocalText(props.label, lang), children: _jsx("a", { onClick: () => goEditMode(), href: "#", children: value ?? '--' }) }));
    }
}
export function EditorDebug(component, index) {
    const [touched, touchedControl] = useToggle({ children: 'Touched' });
    const [invalid, InvalidControl] = useToggle({ children: 'Is Invalid' });
    const [text, setText] = React.useState('text');
    const controls = (_jsxs(_Fragment, { children: [touchedControl, InvalidControl] }));
    return (_jsxs(DebugPage, { controls: controls, children: [_jsx(TextInput, { label: { cs: 'Text', en: 'Text 1' }, name: "text", value: text, onChange: event => setText(event.target.value), isValid: touched && !invalid, isInvalid: invalid, validationMessage: invalid ? 'Validation message' : undefined }), _jsx("hr", {}), _jsx(Property, { title: "Text value", children: text }), _jsx(EditableProperty, { label: { en: 'Editable property' }, value: text, onSubmit: value => {
                    setText(value);
                } })] }));
}
